// extracted by mini-css-extract-plugin
export default {"root":"Km8a5d","leftSide":"SD3Jsu","title":"qYy84a","description":"os31zn","switch":"JTkdWQ"};